import { authHeaders } from './iotApi';
import type { Equipment, Farm, HydraulicLink, IrrigationBlock, Sensor } from '../types/digitalTwin';

const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

export class DigitalTwinApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'DigitalTwinApiError';
  }
}

async function get<T>(path: string): Promise<T> {
  const response = await fetch(`${BASE}/api/v1${path}`, { headers: authHeaders() });
  if (!response.ok) {
    let message = `HTTP ${response.status}`;
    try {
      const body = await response.json();
      if (typeof body.detail === 'string') message = body.detail;
    } catch {
      // Preserve the useful HTTP status when the response has no JSON body.
    }
    throw new DigitalTwinApiError(response.status, message);
  }
  return response.json() as Promise<T>;
}

export const digitalTwinApi = {
  listFarms: () => get<Farm[]>('/farms'),
  listIrrigationBlocks: (farmId: string) =>
    get<IrrigationBlock[]>(`/farms/${encodeURIComponent(farmId)}/irrigation-blocks`),
  listEquipment: (farmId: string) =>
    get<Equipment[]>(`/farms/${encodeURIComponent(farmId)}/equipment`),
  listSensors: (farmId: string) =>
    get<Sensor[]>(`/farms/${encodeURIComponent(farmId)}/sensors`),
  listHydraulicLinks: (farmId: string) =>
    get<HydraulicLink[]>(`/farms/${encodeURIComponent(farmId)}/hydraulic-links`),
};
